<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="dispatchOrderCode"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
    >
      >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:orderso="{ row }">
        <div>
          <span>{{ row.orderSoNo ? row.orderSoNo : '--' }}</span>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          content="调度"
          v-allow="'actDispatch'"
          placement="top"
        >
          <i class="el-icon-aim tool-btn" @click="dispatch(row)"></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="拆单"
          v-allow="'actSplit'"
          placement="top"
          v-if="row.isCanSplit === 'Y'"
        >
          <i class="el-icon-files tool-btn" @click="splitOrder(row)"></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="中转"
          v-allow="'actTransfer'"
          placement="top"
        >
          <i class="el-icon-truck tool-btn" @click="transfer(row)"></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="指定中转"
          v-allow="'actSpecifyTransfer'"
          placement="top"
        >
          <i
            class="el-icon-guide tool-btn"
            @click="disposableTransfer(row)"
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="回退订单"
          v-allow="'actReturnOrder'"
          placement="top"
        >
          <i class="el-icon-refresh-left tool-btn" @click="cancel(row)"></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="订单打印"
          v-allow="'actPrint'"
          placement="top"
        >
          <i class="el-icon-printer tool-btn" @click="print(row)"></i>
        </el-tooltip>
      </template>
      <template v-slot:orderNo="{ row }">
        <div>
          <el-link type="primary" @click="openOrderDetailPage(row.orderNo)">
            {{ row.orderNo }}
          </el-link>
        </div>
      </template>
    </vxe-grid>
    <vxe-modal
      ref="xModal"
      v-model="dialogOption.dialogVisible"
      :title="dialogOption.title"
      :width="dialogOption.width"
      :height="dialogOption.height"
      destroy-on-close
      type="modal"
      resize
    >
      <set-carrier
        v-if="showSetCarrier"
        ref="setCarrier"
        :orderList="selectList"
        @close="close()"
        @saveOk="saveOk()"
      />
      <split-bill
        v-if="showSplit"
        ref="splitBill"
        :formData="splitFormData"
        @close="close()"
        @saveOk="saveOk()"
      />
      <transfer-bill
        v-if="showTransfer"
        ref="splitBill"
        :formData="transferFormData"
        @close="close()"
        @saveOk="saveOk()"
      />
      <disposable-bill
        v-if="showDisposable"
        ref="splitBill"
        :formData="transferFormData"
        @close="close()"
        @saveOk="saveOk()"
      />
      <many-set-carrier
        v-if="showSetManyCarrier"
        ref="setManyCarrier"
        :orderList="selectList"
        @close="close()"
        @saveOk="saveOk()"
      />
    </vxe-modal>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import SplitBill from '../../split-bill'
import TransferBill from '../../transfer-bill'
import DisposableBill from '../../disposable-bill'
import SetCarrier from '../../set-carrier'
import ManySetCarrier from '../../set-carrier/manySetCarrier'
export default {
  components: {
    SplitBill,
    TransferBill,
    SetCarrier,
    ManySetCarrier,
    DisposableBill,
  },
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      dialogOption: {
        title: '',
        dialogVisible: false,
        height: 600,
      },
      selectList: [],
      fullScreenLoading: false,
      dispatchOrderCode: '',
      showSplit: false,
      splitFormData: {},
      showTransfer: false,
      showDisposable: false,
      transferFormData: {},
      showSetCarrier: false,
      showSetManyCarrier: false,
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 204
    },
    dispatch(row) {
      this.showSetCarrier = false
      this.showSetManyCarrier = false
      this.showSplit = false
      this.showTransfer = false
      this.showDisposable = false
      this.selectList = []
      this.selectList.push(row)
      this.dialogOption.title = '指派承运商'
      this.dialogOption.dialogVisible = true
      this.dialogOption.height = '700'
      this.dialogOption.width = '1100'
      this.showSetCarrier = true
    },
    splitOrder(row) {
      this.showSetCarrier = false
      this.showSetManyCarrier = false
      this.showSplit = false
      this.showTransfer = false
      this.showDisposable = false
      let params = {
        dispatchOrderCode: row.dispatchOrderCode,
      }
      this.splitFormData = {}
      this.$api.bizDispatchPoolSplitGetDetailApi(params).then((res) => {
        this.splitFormData = res.body
        this.dialogOption.title =
          '订单拆量 | 原订单编号：' + this.splitFormData.dispatchOrderNo
        this.dialogOption.height = '630'
        this.dialogOption.width = '1100'
        this.dialogOption.dialogVisible = true
        this.showSplit = true
      })
    },
    transfer(row) {
      this.showSetCarrier = false
      this.showSetManyCarrier = false
      this.showSplit = false
      this.showTransfer = false
      this.showDisposable = false
      let params = {
        dispatchOrderCode: row.dispatchOrderCode,
      }
      this.transferFormData = {}
      this.$api.bizDispatchPoolDetailApi(params).then((res) => {
        this.transferFormData = res.body
        this.dialogOption.title =
          '订单中转 | 原订单编号：' +
          this.transferFormData.dispatchOrderNo +
          ' | 客户：' +
          this.transferFormData.custShortName
        this.dialogOption.height = '600'
        this.dialogOption.width = '1100'
        this.dialogOption.dialogVisible = true
        this.showTransfer = true
      })
    },
    disposableTransfer(row) {
      this.close()

      this.transferFormData = {}
      this.transferFormData = row
      this.dialogOption.title =
        '订单中转 | 原订单编号：' +
        this.transferFormData.dispatchOrderNo +
        ' | 客户：' +
        this.transferFormData.custShortName
      this.dialogOption.height = '600'
      this.dialogOption.width = '1100'
      this.dialogOption.dialogVisible = true
      this.showDisposable = true
    },
    cancel(row) {
      this.$confirm(
        '确认要取消调度吗？该订单如果已经被拆量，则相关拆量订单也会一同被取消',
        '确认信息',
        {
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .bizDispatchPoolCancelApi({
            dispatchOrderCode: row.dispatchOrderCode,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
    print(row) {
      this.$api.printPDF('/order/bizDispatchPool/print', {
        dispatchOrderCode: row.dispatchOrderCode,
      })
    },
    transferOneKey(row) {
      console.log(row.dispatchOrderCode)
    },
    async batchDispatch() {
      // 批量调度，多条订单，多条运单
      const selectStatus = await this.getSelectData('row', 100)
      if (!selectStatus) {
        return
      }

      this.close()
      this.dialogOption.title = '指派承运商'
      this.dialogOption.dialogVisible = true
      this.dialogOption.width = '900'
      this.dialogOption.height = '450'
      this.showSetManyCarrier = true
    },
    async batchSchedulDispatch() {
      // 批量调度,多条订单一条运单
      const selectStatus = await this.getSelectData('row', 20)
      if (!selectStatus) return

      const { length } = this.selectList || []
      if (!length) return
      if (length < 2) {
        this.$message({
          message: '合并调度必须选择两个或两个以上的调度订单才能进行合并调度！',
          type: 'warning',
        })
        return
      }

      this.close()

      this.dialogOption.title = '指派承运商'
      this.dialogOption.dialogVisible = true
      this.dialogOption.height = '700'
      this.dialogOption.width = '1100'
      this.showSetCarrier = true
    },
    batchTransfer() {
      console.log('batchTransfer')
    },
    async batchCancel() {
      const selectStatus = await this.getSelectData('code', 100)
      if (!selectStatus) {
        return
      }
      this.$confirm('确认要取消调度勾选的订单吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$api
          .bizDispatchPoolBatchCancelApi({
            listCode: this.selectList,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            // 取消选中状态
            this.removeCheckBox()
            this.$emit('reload')
          })
      })
    },
    getSelectData(selectType, limitation) {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      if (totCount === 0) {
        this.$message.warning('请选择需要批量处理的订单')
        return false
      }
      this.selectList = []
      // 将缓存中的选中数据，加入已选中数据列表
      if (reserveRecords.length > 0) {
        reserveRecords.forEach((row) => {
          if (selectType == 'code') {
            this.selectList.push(row.dispatchOrderCode)
          } else {
            this.selectList.push(row)
          }
        })
      }
      // 将当前页选中数据，加入已选中数据列表
      if (selectRecords.length > 0) {
        selectRecords.forEach((row) => {
          if (selectType == 'code') {
            this.selectList.push(row.dispatchOrderCode)
          } else {
            this.selectList.push(row)
          }
        })
      }
      if (totCount > 100) {
        this.$message.warning(`每次批量选择的订单数量，不能超过100张`)
        return false
      }
      return true
    },
    removeCheckBox() {
      // 清除选中的记录
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
    },
    close() {
      this.showSetCarrier = false
      this.showSplit = false
      this.showTransfer = false
      this.showDisposable = false
      this.showSetManyCarrier = false
      this.dialogOption.dialogVisible = false
    },
    saveOk() {
      // 取消选中状态
      this.removeCheckBox()
      this.dialogOption.dialogVisible = false
      this.$emit('reload')
    },
    openOrderDetailPage(no) {
      this.$router.push({
        name: 'carriage-order-detail-page',
        params: { no },
      })
    },
  },
}
</script>
